"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var viewportStyle_exports = {};
__export(viewportStyle_exports, {
  viewportStyle: () => viewportStyle
});
module.exports = __toCommonJS(viewportStyle_exports);
var import_react_native = require("react-native");
function viewportStyle(style) {
  var flat = import_react_native.StyleSheet.flatten(style);
  var hasSize = (flat === null || flat === void 0 ? void 0 : flat.height) != null || (flat === null || flat === void 0 ? void 0 : flat.aspectRatio) != null || (flat === null || flat === void 0 ? void 0 : flat.flex) != null || (flat === null || flat === void 0 ? void 0 : flat.flexBasis) != null || (flat === null || flat === void 0 ? void 0 : flat.flexGrow) != null;
  return [
    hasSize ? {
      alignSelf: "stretch"
    } : {
      flex: 1,
      alignSelf: "stretch"
    },
    style
  ];
}
//# sourceMappingURL=viewportStyle.js.map
